import {Component, forwardRef, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {AccountPaymentDetailsSearchModel} from "../account-payment-details-search.model";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => AccountPaymentDetailsSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-payment-details-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR,
        provideSearchModel(AccountPaymentDetailsSearchModel)
    ]
})
export class AccountPaymentDetailsSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<AccountPaymentDetailsSearchModel> {
    constructor(model: AccountPaymentDetailsSearchModel, injector: Injector) {
        super(model, injector, "name", "name");
    }
}
